var styles = {"root":"Message-module_root__3fC6m","icon":"Message-module_icon__2Wcsr","info":"Message-module_info__KBo4X","success":"Message-module_success__9ahGn","warning":"Message-module_warning__1XeeE","error":"Message-module_error__3hmit","cta":"Message-module_cta__3sO8O"};

export { styles as default };
//# sourceMappingURL=Message.module.css.js.map
